<template>
  <v-card class="primary ">
    <div
      class="d-flex pa-4 is-active"
      :class="$vuetify.breakpoint.mobile ? 'flex-column' : 'justify-space-between'"
    >
      <div
        class="d-flex"
        :class="$vuetify.breakpoint.mobile ? 'flex-column' : 'w-100'"
        @click="openDetailResume = !openDetailResume" 
      >
        <div
          class="white--text titre-h3  mt-1"
          :class="$vuetify.breakpoint.mobile ? 'mb-3' : 'mr-10 align-self-center'"
        >
          {{ graineRs3.libelle | capitalize }}
        </div>
        <div
          class="d-flex"
          :class="$vuetify.breakpoint.mobile ? 'justify-space-between flex-column' : ''"
        >
          <div
            class="d-flex"
            :class="$vuetify.breakpoint.mobile ? '' : 'mr-10'"
          >
            <span
              class="white--text titre-h1 mr-2 align-self-center"
            >{{ nbApports }}</span>
            <span
              class="white--text intro align-self-center"
            >apport{{ nbApports > 1 ? 's' : '' }}</span>
          </div>
          <div
            class="d-flex"
          >
            <span
              class="white--text intro align-self-center"
            >Poids aux normes</span>
            <span
              class="white--text titre-h1 ml-2 align-self-center"
            >{{ cumulPoidsAuxNormesEnKg }} t</span>
          </div>
        </div>
      </div>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <div
            :class="$vuetify.breakpoint.mobile ? 'mt-3 d-flex' : ''"
            v-on="on"
          >
            <AgrButton
              :disabled="!hasReglementCampagne || loadingReglementCampagne"
              target="_blank"
              text
              @click="onDownloadReglementCampagne"
            >
              <BaseLoader
                v-if="loadingReglementCampagne"
              />
              <v-img
                v-else
                class="ma-2 icon"
                color="white"
                src="@/assets/download/white-tray-arrow-down.svg"
              />
              <span
                :class="$vuetify.breakpoint.mobile ? 'mention' : 'action'"
                class="text-truncate white--text "
              >Règlement de campagne (PDF)</span>
            </AgrButton>
          </div>
        </template>
        {{ tooltipReglementCampagne }}
      </v-tooltip>
      <div
        class="d-flex"
        :class="$vuetify.breakpoint.mobile ? 'mt-4 justify-space-between' : ''"
      >
        <div>
          <AgrButton
            target="_blank"
            text
            :disabled="loadingSynthese"
            @click="clickButton"
          >
            <BaseLoader
              v-if="loadingSynthese"
            />
            <v-img
              v-else
              class="ma-2 icon"
              color="white"
              src="@/assets/download/white-tray-arrow-down.svg"
            />
            <span
              class="text-truncate white--text"
              :class="$vuetify.breakpoint.mobile ? 'mention' : 'action'"
            >Synthèse (PDF)</span>
          </AgrButton>
        </div> 
        <v-divider
          vertical
          class="grey lighten-1 mx-3"
        />
        <div class="align-self-center">
          <v-icon
            color="white"
            large 
            @click="openDetailResume = !openDetailResume"                      
          >
            {{ openDetailResume ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
          </v-icon>
        </div> 
      </div>
    </div>
    <div
      v-if="openDetailResume"
      class="pb-4"
    >
      <v-divider class="grey lighten-1 mb-4 mx-4" />
      <v-row
        :class="$vuetify.breakpoint.mobile ? '' : 'd-flex'"
        no-gutters
      >
        <div
          v-if="!$vuetify.breakpoint.mobile"
          class="primary--text titre-h3 mt-1"
          :class="$vuetify.breakpoint.mobile ? 'mb-3' : 'mr-5 align-self-center'"
        >
          {{ graineRs3.libelle | capitalize }}
        </div>
        <v-col
          v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.poidsSpecifiqueEnKgParHectolitre) && resumeGraineMois.analyseMoyenne.poidsSpecifiqueEnKgParHectolitre"
          :class="$vuetify.breakpoint.mobile ? 'row ml-2' : 'd-flex mx-8 align-self-center'"
          :cols="$vuetify.breakpoint.mobile ? '6': 'auto'"
        >
          <v-col
            class="white--text intro align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pb-0' :''"
            :cols="$vuetify.breakpoint.mobile ? '12': 'auto'"
          >
            PS
          </v-col>
          <v-col
            class="white--text titre-h3 align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pt-0' :''"
          >
            {{ poidsSpecifiqueEnKgParHectolitre }} Kg/hl
          </v-col>
        </v-col>
        <v-col
          v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.humiditeTaux) && resumeGraineMois.analyseMoyenne.humiditeTaux"
          :class="$vuetify.breakpoint.mobile ? 'row ml-2' : 'd-flex mx-8 align-self-center'"
          :cols="$vuetify.breakpoint.mobile ? '6': 'auto'"
        >
          <v-col
            class="white--text intro align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pb-0' :''"
            :cols="$vuetify.breakpoint.mobile ? '12': 'auto'"
          >
            Humidité
          </v-col>
          <v-col
            class="white--text titre-h3 align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pt-0' :''"
          >
            {{ humiditeTaux }} %
          </v-col>
        </v-col>
        <v-col
          v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.impureteTaux) && resumeGraineMois.analyseMoyenne.impureteTaux"
          :class="$vuetify.breakpoint.mobile ? 'row ml-2' : 'd-flex mx-8 align-self-center'"
          :cols="$vuetify.breakpoint.mobile ? '6': 'auto'"
        >
          <v-col
            class="white--text intro align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pb-0' :''"
            :cols="$vuetify.breakpoint.mobile ? '12': 'auto'"
          >
            Impuretés
          </v-col>
          <v-col
            class="white--text titre-h3 align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pt-0' :''"
          >
            {{ impureteTaux }} %
          </v-col>
        </v-col>
        <v-col
          v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.proteineTaux) && resumeGraineMois.analyseMoyenne.proteineTaux"
          :class="$vuetify.breakpoint.mobile ? 'row ml-2' : 'd-flex mx-8 align-self-center'"
          :cols="$vuetify.breakpoint.mobile ? '6': 'auto'"
        >
          <v-col
            class="white--text intro align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pb-0' :''"
            :cols="$vuetify.breakpoint.mobile ? '12': 'auto'"
          >
            Protéines
          </v-col>
          <v-col
            class="white--text titre-h3 align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pt-0' :''"
          >
            {{ proteineTaux }} %
          </v-col>
        </v-col>
        <v-col
          v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.tempsChuteHacbergEnSeconde) && resumeGraineMois.analyseMoyenne.tempsChuteHacbergEnSeconde"
          :class="$vuetify.breakpoint.mobile ? 'row ml-2' : 'd-flex mx-8 align-self-center'"
          :cols="$vuetify.breakpoint.mobile ? '6': 'auto'"
        >
          <v-col
            class="white--text intro align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pb-0' :''"
            :cols="$vuetify.breakpoint.mobile ? '12': 'auto'"
          >
            Hagberg
          </v-col>
          <v-col
            class="white--text titre-h3 align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pt-0' :''"
          >
            {{ tempsChuteHacbergEnSeconde }} s
          </v-col>
        </v-col>
        <v-col
          v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.echaudeBriseTaux) && resumeGraineMois.analyseMoyenne.echaudeBriseTaux"
          :class="$vuetify.breakpoint.mobile ? 'row ml-2' : 'd-flex mx-8 align-self-center'"
          :cols="$vuetify.breakpoint.mobile ? '6': 'auto'"
        >
          <v-col
            class="white--text intro align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pb-0' :''"
            :cols="$vuetify.breakpoint.mobile ? '12': 'auto'"
          >
            Echaudé, brisé
          </v-col>
          <v-col
            class="white--text titre-h3 align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pt-0' :''"
          >
            {{ echaudeBriseTaux }} %
          </v-col>
        </v-col>
        <v-col
          v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.germeMitadineFusarieTaux) && resumeGraineMois.analyseMoyenne.germeMitadineFusarieTaux"
          :class="$vuetify.breakpoint.mobile ? 'row ml-2' : 'd-flex mx-8 align-self-center'"
          :cols="$vuetify.breakpoint.mobile ? '6': 'auto'"
        >
          <v-col
            class="white--text intro align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pb-0' :''"
            :cols="$vuetify.breakpoint.mobile ? '12': 'auto'"
          >
            Germé, mitadiné, fusarié
          </v-col>
          <v-col
            class="white--text titre-h3 align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pt-0' :''"
          >
            {{ germeMitadineFusarieTaux }} %
          </v-col>
        </v-col>
        <v-col
          v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.impureteGrainTaux) && resumeGraineMois.analyseMoyenne.impureteGrainTaux"
          :class="$vuetify.breakpoint.mobile ? 'row ml-2' : 'd-flex mx-8 align-self-center'"
          :cols="$vuetify.breakpoint.mobile ? '6': 'auto'"
        >
          <v-col
            class="white--text intro align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pb-0' :''"
            :cols="$vuetify.breakpoint.mobile ? '12': 'auto'"
          >
            Impureté, mitadiné, germé
          </v-col>
          <v-col
            class="white--text titre-h3 align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pt-0' :''"
          >
            {{ impureteGrainTaux }} %
          </v-col>
        </v-col>
        <v-col
          v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.mitadineTaux) && resumeGraineMois.analyseMoyenne.mitadineTaux"
          :class="$vuetify.breakpoint.mobile ? 'row ml-2' : 'd-flex mx-8 align-self-center'"
          :cols="$vuetify.breakpoint.mobile ? '6': 'auto'"
        >
          <v-col
            class="white--text intro align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pb-0' :''"
            :cols="$vuetify.breakpoint.mobile ? '12': 'auto'"
          >
            Mitadiné
          </v-col>
          <v-col
            class="white--text titre-h3 align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pt-0' :''"
          >
            {{ mitadineTaux }} %
          </v-col>
        </v-col>
        <v-col
          v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.zelenyIndiceEnMillilitre) && resumeGraineMois.analyseMoyenne.zelenyIndiceEnMillilitre"
          :class="$vuetify.breakpoint.mobile ? 'row ml-2' : 'd-flex mx-8 align-self-center'"
          :cols="$vuetify.breakpoint.mobile ? '6': 'auto'"
        >
          <v-col
            class="white--text intro align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pb-0' :''"
            :cols="$vuetify.breakpoint.mobile ? '12': 'auto'"
          >
            Zeleny
          </v-col>
          <v-col
            class="white--text titre-h3 align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pt-0' :''"
          >
            {{ zelenyIndiceEnMillilitre }} mL
          </v-col>
        </v-col>
        <v-col
          v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.grainBrucheTaux) && resumeGraineMois.analyseMoyenne.grainBrucheTaux"
          :class="$vuetify.breakpoint.mobile ? 'row ml-2' : 'd-flex mx-8 align-self-center'"
          :cols="$vuetify.breakpoint.mobile ? '6': 'auto'"
        >
          <v-col
            class="white--text intro align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pb-0' :''"
            :cols="$vuetify.breakpoint.mobile ? '12': 'auto'"
          >
            Grains bruchés
          </v-col>
          <v-col
            class="white--text titre-h3 align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pt-0' :''"
          >
            {{ grainBrucheTaux }} %
          </v-col>
        </v-col>
        <v-col
          v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.grainCasseTaux) && resumeGraineMois.analyseMoyenne.grainCasseTaux"
          :class="$vuetify.breakpoint.mobile ? 'row ml-2' : 'd-flex mx-8 align-self-center'"
          :cols="$vuetify.breakpoint.mobile ? '6': 'auto'"
        >
          <v-col
            class="white--text intro align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pb-0' :''"
            :cols="$vuetify.breakpoint.mobile ? '12': 'auto'"
          >
            Grains cassés
          </v-col>
          <v-col
            class="white--text titre-h3 align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'pt-0' :''"
          >
            {{ grainCasseTaux }} %
          </v-col>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import { AgrButton } from '@agrial/ui'
import BaseLoader from '@/components/common/base-loader.vue'
import caracteristiques from '@/model/caracteristiquesGraines'
import { round } from 'lodash'

export default {
  name: 'ResumeDetailMensuel',
  components: { AgrButton, BaseLoader },
  props: {
    resumeGraineMois: {
      type: Object,
      default: () => { }
    },
    graineRs3: {
      type: Object,
      required: true
    },
    nbApports: {
      type: Number,
      default: null
    },
    loadingSynthese: {
      type: Boolean,
      default: false
    },
    hasReglementCampagne: {
      type: Boolean,
      default: false
    },
    loadingReglementCampagne: {
      type: Boolean,
      default: false
    },
    tooltipReglementCampagne: {
      type: String,
      default: null
    },
  },

  data () {
    return {
      caracteristiques,
      openDetailResume: false
    }
  },
  computed: {
    cumulPoidsAuxNormesEnKg () {
      return round(this.resumeGraineMois.cumulPoidsAuxNormesEnKg / 1000, 3).toString().replace(/\./g, ',')
    },
    poidsSpecifiqueEnKgParHectolitre () {
      return round(this.resumeGraineMois.analyseMoyenne.poidsSpecifiqueEnKgParHectolitre, 1).toString().replace(/\./g, ',')
    },
    humiditeTaux () {
      return round(this.resumeGraineMois.analyseMoyenne.humiditeTaux, 1).toString().replace(/\./g, ',')
    },
    impureteTaux () {
      return round(this.resumeGraineMois.analyseMoyenne.impureteTaux, 1).toString().replace(/\./g, ',')
    },
    proteineTaux () {
      return round(this.resumeGraineMois.analyseMoyenne.proteineTaux, 1).toString().replace(/\./g, ',')
    },
    tempsChuteHacbergEnSeconde () {
      return round(this.resumeGraineMois.analyseMoyenne.tempsChuteHacbergEnSeconde, 1).toString().replace(/\./g, ',')
    },
    echaudeBriseTaux () {
      return round(this.resumeGraineMois.analyseMoyenne.echaudeBriseTaux, 1).toString().replace(/\./g, ',')
    },
    germeMitadineFusarieTaux () {
      return round(this.resumeGraineMois.analyseMoyenne.germeMitadineFusarieTaux, 1).toString().replace(/\./g, ',')
    },
    impureteGrainTaux () {
      return round(this.resumeGraineMois.analyseMoyenne.impureteGrainTaux, 1).toString().replace(/\./g, ',')
    },
    mitadineTaux () {
      return round(this.resumeGraineMois.analyseMoyenne.mitadineTaux, 1).toString().replace(/\./g, ',')
    },
    zelenyIndiceEnMillilitre () {
      return round(this.resumeGraineMois.analyseMoyenne.zelenyIndiceEnMillilitre, 1).toString().replace(/\./g, ',')
    },
    grainBrucheTaux () {
      return round(this.resumeGraineMois.analyseMoyenne.grainBrucheTaux, 1).toString().replace(/\./g, ',')
    },
    grainCasseTaux () {
      return round(this.resumeGraineMois.analyseMoyenne.grainCasseTaux, 1).toString().replace(/\./g, ',')
    }
  },
  methods: {
    clickButton () {
      this.$emit('button')
    },
    onDownloadReglementCampagne () {
      this.$emit('download-reglement-campagne')
    }
  }

}
</script>

<style lang="scss" scoped>
.icon {
  width: 1.7em;
}
.is-active:hover {
  background-color: #7a8001;
  cursor: pointer;
}
</style>
